import { api } from 'store/api/strapiService';

export const promotionsController = api.injectEndpoints({
  endpoints: (build) => ({
    getPromotions: build.query({
      //TODO: remove hardcoded limit after adding infinite scroll on category page
      query: ({ provider, dateFilters, sortByMain, market, limit = 1000 }) => ({
        url: '/api/promotions',
        params: {
          'filters[provider][$eq]': provider,
          'filters[enabled][$eq]': true,
          'filters[isPhase][$eq]': false,
          'pagination[limit]': limit,
          'populate[market]': true,
          'populate[tags]': true,
          'populate[promotions][populate][tags]': true,
          sort: `${sortByMain ? 'isMain:desc,' : ''}startDate:desc`,
          ...(market && {
            'filters[market][item][$eq]': market,
          }),
          ...dateFilters,
        },
      }),
    }),
    getPromotion: build.query({
      query: ({ id }) => ({
        url: `/api/promotions/${id}`,
        params: {
          'filters[enabled][$eq]': true,
          'populate[gamesParticipating]': true,
          'populate[languages]': true,
          'populate[market]': true,
          'populate[placeAndPrize]': true,
          'populate[tags]': true,
          'populate[promotions][populate][gamesParticipating]': true,
          'populate[promotions][populate][languages]': true,
          'populate[promotions][populate][market]': true,
          'populate[promotions][populate][placeAndPrize]': true,
          'populate[promotions][populate][tags]': true,
        },
      }),
    }),
  }),
});

export const { useGetPromotionsQuery, useGetPromotionQuery } =
  promotionsController;
